module.exports = __webpack_public_path__ + "img/homepage-quick-links-kia.b975a476.jpg";